define.alias("ember-math-helpers/helpers/random", "calendar/helpers/random");